import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Movies from "./pages/Movies";
import Player from "./pages/Player";
import Sports from "./pages/Sports";
import MainLayout from "./layout/MainLayout";
import OttChannels from "./pages/OttChannels";


import "./styles/tv.css";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* COMMON LAYOUT */}
        <Route element={<MainLayout />}>

          <Route path="/" element={<Home />} />
          <Route path="/movies/:id" element={<Movies />} />
          <Route path="/sports" element={<Sports />} />
          <Route path="/ott" element={<OttChannels/>}/>

        </Route>

        {/* FULL SCREEN PLAYER (no layout) */}
        <Route path="/play/:app/:mid" element={<Player />} />

      </Routes>
    </BrowserRouter>
  );
}
